import { render, staticRenderFns } from "./MainInfo.vue?vue&type=template&id=4fc379c2"
import script from "./MainInfo.vue?vue&type=script&lang=js"
export * from "./MainInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports